<template>
  <div :class="$style.register">
    <h3>Create Account</h3>
    <p :class="$style.exampleText">Create an account with Vitruvian Size Suggestion Tool to save your measurements</p>
    <form @submit.prevent @submit="submit">
      <input
        v-model="form.firstName"
        name="first name"
        v-validate="'required'"
        :class="$style.input"
        type="text"
        placeholder="First Name"
      >
      <input
        v-model="form.lastName"
        name="last name"
        v-validate="'required'"
        :class="$style.input"
        type="text"
        placeholder="Last Name"
      >
      <input
        v-model="form.email"
        name="email"
        v-validate="'required|email'"
        :class="$style.input"
        type="email"
        placeholder="Email Address"
      >
      <input
        v-model="form.password"
        name="password"
        :class="$style.input"
        v-validate="'confirmed:password2'"
        type="password"
        placeholder="Password"
        
      >
      <input
        v-model="form.password2"
        name="repeat password"
        ref="password2"
        :class="$style.input"
        type="password"
        v-validate="'required'"
        placeholder="Repeat Password"
      >
      <div :class="$style.errors">{{serverResponse}}</div>
      <button type="submit" :class="$style.submit" :disabled="!isValid">JOIN</button>
      <div :class="$style.errors">{{errorMessage}}</div>
      <div :class="$style.caption" @click="$emit('setActiveModal', 'LogIn')">Log In</div>
    </form>

  </div>
</template>

<script>
import axios from 'axios'
import { mapMutations, mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['canvasOutput']),
    errorMessage() {
      return this.errors.items.map(i => i.msg).join('\n')
    },
    isValid() {
      return Object.values(this.form).every(s => s.length) &&
        !this.errors.items.length
    }
  },
  data() {
    return {
      serverResponse: '',
      form: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        password2: ''
      }
    }
  },
  methods: {
    ...mapMutations(['setUser']),
    submit() {
      axios.post(process.env.VUE_APP_SERVER + '/create_user.php', { ...this.form, ...this.canvasOutput })
        .then((r) => {
          this.setUser(r.data.user)
          localStorage.setItem(process.env.JWT_KEY, r.data.jwt)
          this.$emit('setActiveModal', 'Main')
        })
        .catch(({ response }) => {
          this.serverResponse = response.data.message
        })
    }
  }
}
</script>


<style lang="scss" module>
.input {
  display: block;
  padding: 10px;
  width: 100%;
  margin: 10px 0;
}

.submit {
  display: block;
  width: 100%;
  border: 0;
  outline: 0;
  padding: 10px;
  background-color: rgb(39, 120, 173);
  color: #fff;
  cursor: pointer;
  transition: .2s;

  &:disabled {
    background-color: #999;
  }

  &:not(:disabled):hover {
    background-color: rgb(24, 96, 145);
  }
}

.register {
  margin-bottom: 20px;
}

.caption {
  text-align: center;
  display: block;
  margin-top: 10px;
  font-size: 10px;
  cursor: pointer;
}

.errors {
  color: rgb(214, 69, 69);
  font-size: 11px;
  margin-top: 10px;
  height: 20px;
}
.exampleText {
  display: flex;
  justify-content: center;
  font-size: small;
  color: rgb(111, 118, 124);

}
</style>
